import * as React from 'react';
import { Button } from '@/components/ui/Button';
import clsx from 'clsx';

interface LinkInputSectionProps {
  onAddLink: (url: string) => void;
}

export const LinkInputSection: React.FC<LinkInputSectionProps> = ({ onAddLink }) => {
  const [url, setUrl] = React.useState('');

  const handleAdd = () => {
    const trimmed = url.trim();
    if (trimmed) {
      onAddLink(trimmed);
      setUrl('');
    }
  };

  return (
    <div className='mb-4 w-full'>
      <h4 className='mb-1 font-sans text-20 font-medium leading-27 text-dark-100'>
        Add Links - Where You Can Find More About You
      </h4>
      <p className='mb-4 font-sans text-16 font-medium leading-27 text-gray-530'>
        YouTube, Instagram, Articles, or any public content
      </p>

      <div className='flex w-full flex-col gap-4 md:flex-row'>
        <input
          type='text'
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder='Type Your Link...'
          className={clsx(
            'h-[44px] min-h-[44px] flex-1 px-4',
            'rounded-10 border border-gray-120 bg-white',
            'font-sans text-14 font-normal leading-160 tracking-[-0.02em]',
            'text-gray-560 placeholder:text-gray-450',
            'focus:border-brand-300 focus:outline-none'
          )}
        />

        <Button
          variant='settings-modify'
          onClick={handleAdd}
          className='h-[44px] w-full md:w-[154px]'
        >
          Add Link
        </Button>
      </div>
    </div>
  );
};
